import { FormikProps } from 'formik';
import { useEffect } from 'react';

type Props<T, AccordionKey extends string> = {
    formik: FormikProps<T>;
    accordions?: {
        state: [Record<AccordionKey, boolean>, React.Dispatch<React.SetStateAction<Record<AccordionKey, boolean>>>];
        fieldsPerAccordion: Record<AccordionKey, (keyof T)[]>;
    };
};

const useScrollIntoError = <T, AccordionKey extends string>({ formik, accordions }: Props<T, AccordionKey>) => {
    const [_accordionsState, setAccordions] = accordions?.state ?? [null, null];

    const submitting = formik?.isSubmitting;
    const scrollIntoError = () => {
        setTimeout(() => {
            const el = document.querySelector('.Mui-error, [data-error]');
            const element = el?.parentElement ?? el;
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 100);
    };

    useEffect(() => {
        if (submitting) {
            scrollIntoError();
        }
    }, [submitting]);

    useEffect(() => {
        if (!formik.submitCount || !accordions) {
            return;
        }

        setAccordions?.((prev) => {
            const newState = { ...prev };
            for (const [accordionKey, fields] of Object.entries(accordions.fieldsPerAccordion)) {
                if ((fields as (keyof T)[]).some((field) => formik.errors[field])) {
                    newState[accordionKey as AccordionKey] = true;
                }
            }
            return newState;
        });
    }, [formik.errors, formik.submitCount]);

    return { scrollIntoError };
};

export { useScrollIntoError };
